module.exports = __webpack_public_path__ + "static/media/error.151f2238.svg";